export const CONFIRM_EMAIL_EMAIL_CONFIRMED_SUCCESS =
  'gustav/confirm_email/EMAIL_CONFIRMED_SUCCESS';

export const CONFIRM_EMAIL_ERROR = 'gustav/confirm_email/CONFIRM_EMAIL_ERROR';
